export const trailingSlash = 'always';